<template>
  <div id="agreement">
    <div class="tBox">服务协议</div>
    <div class="box container">
      <div v-for="(item,index) of data" :key="index">
        <div class="t">{{item.title}}</div>
        <div v-html="item.content"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //
      serve: this.$store.state.serve,
      data: {}
    };
  },
  created() {
    this.axios
      .get(this.serve + "/get_register_agreement")
      .then(res => {
        this.data = res.data.data;
      });
  },
  methods: {
    //
  }
};
</script>
<style lang="scss">
#agreement {
  padding: 20px 0 50px 0;
  .tBox {
    background-color: #000;
    font-size: 35px;
    padding: 60px 0;
    text-align: center;
    color: #fff;
    letter-spacing: 10px;
    font-family: "宋体";
    font-weight: 1000;
    margin-bottom: 20px;
  }
  .box {
    background-color: #fff;
    line-height: 2em;
    padding: 30px 0;
    div {
      padding: 0 20px;
    }
    .t {
      font-weight: bold;
      font-size: 16px;
      margin: 20px 0 10px 0;
    }
  }
}
</style>